import { uniqWith } from "lodash";
import { Idle, IdleDetailingItem } from "../../../../../../../types/service/dashboard/IWorksDashboardService";
import { useMemo } from "react";

type ChartValue = { data: number[] } & Idle;
type ItemKey = 'plannedIdlesByType' | 'unplannedIdlesByType';

export const useIdlesChartValues = (key: ItemKey, elements: IdleDetailingItem[]) => useMemo<ChartValue[]>(() => {
    const idles = uniqWith(elements.flatMap(elem => elem[key]), (a, b) => a.typeOfIdle === b.typeOfIdle);

    return idles.map(idle => ({
        color: idle.color,
        data: elements.map(element =>
            (element[key].find(idleForDate => idleForDate.typeOfIdle === idle.typeOfIdle)?.fact || 0)
        ),
        ...idle,
    }));
}, [key, elements]);